import React from "react";
import { useState, useEffect } from "react";
import { Footer } from "../../components/Footer";
import { Nav } from "../../components/Nav";
import "./style.css";
import { ContactForm } from "../../components/ContactForm";
import { JobPosts } from "../../components/JobPosts/JobPosts";

import Loading  from "../../components/Loading/Loading";


export const JobsPage = () => {
  const [jobs, setJobs] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);


   useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch("/api/jobsList", {
          method: "GET",
          headers: {
            accept: "application/json",
          }
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Error ${response.status}: ${errorText}`);
        }

        const data = await response.json();
        setJobs(data.jobsData);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        console.error("API error:", err);
        //setLoading(false);
      }
    };

    fetchJobs();
  }, []);


  return (
    <div className="main jobs" id="jobs">
                <div className="overlap">
                <div className="content">
                    <div className="element hero bg-white">
                        <div className="frame">
                            <p className="heading color-black">
                           Discover exciting career opportunities that match your skills and aspirations. At recruit22, we pride ourselves on connecting talented individuals with top-notch companies.
                            </p>
                        </div>
                        <div className="image">
                            <div className="group">
                                <div className="rectangle" />
                            </div>
                        </div>
                        <div className="frame">
                          <div className="block-right">
                            <div className="contact-frame">
                            <div className="block-text color-black">
                              Our job listings are carefully curated, featuring a wide range of positions across various industries. Whether you're an experienced professional 
                              seeking new challenges or a fresh graduate looking to kick-start your career, our platform offers a diverse selection of roles that could be your next career move.
                            </div>

                            </div>
                          </div>
                        </div>
                    </div>
                    <div className="element bg-gray" id="jobPosts">
                        <div className="frame">
                          <p className="heading color-black">
                           Current Openings
                            </p>
                            {
                              (loading)? <Loading /> : <JobPosts jobsData={jobs} />
                            }
                            
                        </div>
                    </div>
                      <div className="element bg-dark-blue">
                          <div className="frame">
                              <div className="block-right">
                                  <div className="contact-frame">
                                      <div className="block-title color-white">
                                      If you haven’t found the perfect role on our website, we invite you to connect with us.
                                      </div>
                                      <div className="block-text color-white">
                                      <p>Whether you’re an experienced professional or embarking on your career journey, we are always eager to engage with talented individuals.</p>
                                      <p>Our team is dedicated to matching exceptional talent with exciting opportunities. Don’t hesitate to get in touch with us directly, and let’s explore how we can achieve great things together.</p>
                                       </div>
                                      <ContactForm />
                                  </div>
      
                              </div>
                          </div>
                      </div>
                    <Footer
                        footer="default"
                    />
                </div>
                <Nav className="nav-instance" nav="default" />
                </div>
            </div>
            
  );
};
